import { selectCompanies } from '@modules/admin/Admin.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import './MultiSelect.scss'
import { compose } from 'redux'
import SelectField from './SelectField'

class SelectCompanyField extends Component {
  static defaultProps = {
    companies: [],
    valueKey: 'api_key',
  }

  render() {
    const { companies, placeholder, multi, t } = this.props
    return (
      <SelectField
        placeholder={placeholder || `${multi ? t('Compañías') : t('Compañía')}`}
        {...this.props}
        options={companies}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  companies: selectCompanies(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectCompanyField)
